import { DownloadSimple } from '@phosphor-icons/react';
import { Button, Icon, Text } from '@shh/ui';
import { useState } from 'react';
import { install, useInstallOffer } from '../lib/install';
import { todayText } from '../i18n/today';

const KEY = 'shh.install.asked';

const asked = () => {
  try {
    return localStorage.getItem(KEY) === 'done';
  } catch {
    return false;
  }
};

/** True when "Heute" should show the install card instead of the push question. */
export function useShowInstall(): boolean {
  const offer = useInstallOffer();
  const [hidden] = useState(asked);
  return offer && !hidden;
}

/**
 * Once on "Heute" (W9): "Auf den Startbildschirm?" where the browser offers installing – then
 * Larovi Home starts like an app, without the browser bar. Comes before the push question, so
 * there is only ever one card.
 */
export function InstallPrompt({ onDone }: { onDone: () => void }) {
  const done = () => {
    try {
      localStorage.setItem(KEY, 'done');
    } catch {
      /* private mode: the card shows again next time */
    }
    onDone();
  };
  return (
    <section
      aria-label={todayText.installLabel}
      className="flex flex-col gap-gap-sm rounded-card bg-accent-secondary-soft p-inset-sm"
    >
      <span className="flex items-center gap-gap-sm font-bold">
        <Icon icon={DownloadSimple} size="md" className="text-accent-secondary" />
        {todayText.installTitle}
      </span>
      <Text size="sm">{todayText.installText}</Text>
      <div className="flex flex-wrap gap-gap-sm">
        <Button icon={DownloadSimple} onPress={() => void install().finally(done)}>
          {todayText.install}
        </Button>
        <Button variant="quiet" onPress={done}>
          {todayText.dontShow}
        </Button>
      </div>
    </section>
  );
}
